import * as React from 'react';
import { Box } from '@mui/material';
import { connect } from "react-redux";
import { verifyAccount } from '../../app/store/actions/authActions';
import { Navigate, useParams } from "react-router-dom";
import { MainInput } from '../../app/components/Styles';
import { MarketingFormPage, MarketingButton } from '../../app/components/marketing';

export const VerifyAccount = ({ verifyAccount, user, isLoading }) => {
    const { token } = useParams();

    if (user) {
        return (<Navigate to="/User" replace />);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        verifyAccount({ passcode: data.get('passcode'), token });
    };

    return (
        <MarketingFormPage
            maxWidth="sm"
            title="Verify your account"
            subtitle="Enter the 6-digit code sent to your email"
            loading={isLoading}
        >
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                <MainInput
                    margin="normal"
                    sx={{ my: 1 }}
                    required
                    fullWidth
                    name="passcode"
                    label="Passcode"
                    type="number"
                    inputProps={{ inputMode: 'numeric', pattern: '^[0-9]{6,6}$' }}
                    id="passcode"
                />
                <MarketingButton type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                    Verify account
                </MarketingButton>
            </Box>
        </MarketingFormPage>
    );
};

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.auth?.isLoading,
});

const mapDispatchToProps = { verifyAccount };

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAccount);
